import React, { useCallback, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./../../index.css";
import "./../../mainslider.css"
import { Autoplay } from "swiper";
import axios from 'axios';
import { baseUrl } from '../../utils/baseUrl.js';
import { Link } from 'react-router-dom';
// import brandImg from "./../../assets/brand.366eac1abe784c4755c0.jpg"
import { AiOutlineDoubleRight } from 'react-icons/ai';

const BrandSlider = () => {
    const [brands, setBrands] = useState([])

    const getBrands = useCallback(async () => {
        await axios.get(`${baseUrl}/brands`).then(response => {
            setBrands(response.data?.brands)
        }).catch(err => {
        })
    }, [])

    useEffect(() => {
        getBrands()
    }, [getBrands])



    return (
        <>
            {brands ?
                <div className="flex relative gap-4 my-3 bg-gray-50">
                    <h2 className="text-lg sm:text-xl md:text-2xl md:px-5 p-2 flex items-center gap-2 shadow-custom bg-slate-100 font-bold">Brands <AiOutlineDoubleRight size={20} /></h2>
                    <Swiper
                        breakpoints={{
                            280: {
                                width: 280,
                                slidesPerView: 3,
                            },
                            375: {
                                width: 375,
                                slidesPerView: 3,
                            },
                            425: {
                                width: 425,
                                slidesPerView: 3,
                            },
                            576: {
                                width: 576,
                                slidesPerView: 4,
                            },
                            768: {
                                width: 768,
                                slidesPerView: 6,
                            },
                            1024: {
                                width: 1024,
                                slidesPerView: 8,
                            },
                            2048: {
                                width: 2048,
                                slidesPerView: 9,
                            },
                        }}
                        modules={[Autoplay]}
                        spaceBetween={30}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        className="h-auto cursor-pointer select-none m-auto-lg flex justify-center items-center">
                        {brands.map((brand, i) => (
                            <SwiperSlide key={i} className="bg-slate-800 p-2 m-0">
                                <Link to={`/brands/${brand._id}`}>
                                    <img src={brand.logo?.path} className="w-full brand-images" alt="" />
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div> : ""}
        </>
    )
}

export default BrandSlider